import { useMemo } from 'react';
import { FieldArrayWithId } from 'react-hook-form';

import { MalfunctionNotificationRecipient } from '../domain/models/malfunction-notification';

type RecipientFields = FieldArrayWithId<{ recipients: MalfunctionNotificationRecipient[] }, 'recipients', 'id'>;

type SortedRecipient = {
  field: RecipientFields;
  index: number;
};

const useSortedRecipients = (fields: RecipientFields[]): SortedRecipient[] =>
  useMemo(() => fields.map((field, index) => ({ field, index })).sort((a, b) => a.field.email.localeCompare(b.field.email)), [fields]);

export default useSortedRecipients;
